import type { ReactNode } from 'react'
import { H5, Text } from '@/components/atoms'

interface BenefitCardProps {
  image: ReactNode
  title: string
  description: ReactNode
  className?: string
  imageContainerSize?: string
  variant?: 'horizontal' | 'vertical'
}

export function BenefitCard({
  image,
  title,
  description,
  className = '',
  imageContainerSize = '',
  variant = 'horizontal',
}: BenefitCardProps) {
  if (variant === 'vertical') {
    const imageSizing =
      imageContainerSize ||
      'h-38.75 w-full max-w-86 self-center md:h-full md:max-h-43.5 md:max-w-55 md:self-start'
    return (
      <div className={`flex h-full w-full flex-col gap-6 ${className}`}>
        <div
          className={`overflow-hidden rounded-2xl bg-indigo-50 ${imageSizing}`}
        >
          {image}
        </div>
        <div className="flex flex-col gap-1">
          <H5 className="text-neutral-900">{title}</H5>
          <Text className="text-neutral-900">{description}</Text>
        </div>
      </div>
    )
  }

  return (
    <div
      className={`flex flex-col gap-6 md:flex-row md:items-center ${className}`}
    >
      <div className="h-[9.5625rem] w-full overflow-hidden rounded-2xl bg-indigo-50 md:h-[8.0625rem] md:w-[10.182rem] md:shrink-0">
        {image}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <H5 className="leading-7.5! text-neutral-900">{title}</H5>
        <Text className="text-neutral-900">{description}</Text>
      </div>
    </div>
  )
}
